export const environment = {
	production: false,
	API_URL: "https://cdm-api.3cubehealth.com/",
	File_Storage_URL: "https://backend-content-storage.s3.ap-south-1.amazonaws.com/",
	WELCOME_MAIL_CC: ["sjogi@3cubemedicare.com"],
	version: "1.0.1"
};